import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ModalDelete, PagePath } from '..';
import { api } from '../../services/api';
import { getToken } from '../../services/auth';
import { ApplicationState } from '../../store';
import { populateVehicles } from '../../store/ducks/tables/actions';
import { Vehicle } from '../../store/ducks/tables/types';
import ActivityIndicator from '../ActivityIndicator';
import './styles.scss';

const MOCKED_DATA = {
  placa: 'PFT-0955',
  modelo: 'Constellation 24280',
  capacidadeDeCarga: 14000,
  peso: 23000,
  larguraDoBau: 2,
  comprimentoDobau: 6.5,
  tipoDeVeiculo: 'Bitrem',
  motorista: 'Eduardo Maia da Fonte',
};

const VehicleInfo: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams<{ id?: string }>();
  const { vehicleTypes } = useSelector(
    (state: ApplicationState) => state.tables,
  );
  const token = getToken();
  const [loading, setLoading] = useState<boolean>(false);
  const [modalFlag, setModalFlag] = useState<boolean>(false);
  const [currentVehicle, setCurrentVehicle] = useState<Vehicle>({} as Vehicle);

  const deleteVehicle = () => {
    setLoading(true);
    api
      .delete(`/admins/vehicle_data/${id}`, {
        headers: { Authorization: token },
      })
      .then(response => {
        if (response.data.error) {
          toast.error(`${response.data.error}`);
          setLoading(false);
          return;
        }
        dispatch(populateVehicles([]));
        history.goBack();
        toast.success('Tipo de Veículo deletado com sucesso!');
        setLoading(false);
      });
  };

  const loadVehicleData = useCallback(() => {
    setLoading(true);
    api
      .get(`/admins/vehicle_data/${id}`, { headers: { Authorization: token } })
      .then(response => {
        if (response.data.error) {
          toast.error(`${response.data.error}`);
          setLoading(false);
          return;
        }
        setCurrentVehicle({
          ...(response.data as Vehicle),
          vehicle_type_id: '',
        });

        setLoading(false);
      });
  }, [token, vehicleTypes]);

  useEffect(() => {
    if (id) {
      loadVehicleData();
    }
  }, [id, loadVehicleData, vehicleTypes]);

  const onNavigationClick = useCallback(
    (path: string) => {
      history.push(path);
    },
    [history],
  );

  if (loading) {
    return <ActivityIndicator />;
  }

  return (
    <>
      <ModalDelete
        onHide={() => setModalFlag(false)}
        show={modalFlag}
        onConfirmClick={() => deleteVehicle()}
      />
      <div className="container-body container-vehicle">
        <h5>Placa</h5>
        <p> {currentVehicle.license_plate} </p>
        <h5>Modelo</h5>
        <p> {currentVehicle.model} </p>
        <h5>Capacidade de carga</h5>
        <p> {currentVehicle.load_capacity} </p>
        <h5>Peso</h5>
        <p> {currentVehicle.weight} </p>
        <h5>Largura do baú</h5>
        <p> {currentVehicle.chest_width} </p>
        <h5>Comprimento do baú</h5>
        <p> {currentVehicle.chest_length} </p>
        <h5>Tipo de Veículo</h5>
        <p> {currentVehicle.vehicle_type_id} </p>
        <h5>Motorista</h5>
        <p> {MOCKED_DATA.motorista} </p>
      </div>
    </>
  );
};

export default VehicleInfo;
